<template>
    <div>
        <div class="advance-select-output-container-xl">
            <div class="d-flex">
                <p class="primary-color fsz-12 me-2">You Work on</p>
                <div class="advance-drop-menu-outer-container-xl">
                    <div
                        v-show="!showItemsMenu"
                        class="advance-drop-menu-collapse-container-xl"
                        @click="showItemsMenu = !showItemsMenu"
                    >
                        <span class="fsz-12 fw-bold accent-color">{{
                            vsStore.catalogueTypeTitle
                        }}</span>
                        <img src="@/assets/services/expand-accent.svg" alt="" />
                    </div>
                    <div v-show="showItemsMenu" class="advance-drop-menu-expand-container-xl">
                        <p @click="changeCatalogueTypeTitle('single')">Single</p>
                        <div>
                            <div
                                v-for="(multi, index) in multipleCatalogueLocal"
                                :key="index"
                                @click="changeCatalogueTypeTitle(index)"
                            >
                                Multiple Set#{{ index + 1 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div role="button" class="d-flex align-items-center" @click="newMultiple">
                <img src="@/assets/services/vs/plus-icon.svg" alt="" />
                <span class="primary-color fsz-12 ms-1">New Multiple</span>
            </div>
        </div>
        <div class="advance-select-catalogues-container-xl">
            <div>
                <img src="@/assets/services/vs/room-type-icon.svg" alt="" />
                <span class="primary-color fsz-12 ms-2"
                    >Choose your favourite <strong>Catalogues</strong>, and we’ll stage it.</span
                >
            </div>
            <div class="d-flex flex-wrap justify-content-start fsz-12">
                <div
                    v-for="(catalogue, index) in advancedModeCatalogs"
                    :key="index"
                    role="button"
                    class="me-4 mt-4 d-flex flex-column justify-content-center align-items-center"
                    @click="changeCatalogue(index)"
                >
                    <p
                        :class="[
                            indexOfSelectedCategory === index
                                ? 'fsz-12 accent-color fw-bold'
                                : 'fsz-12 primary-color',
                        ]"
                    >
                        {{ catalogue.name }}
                    </p>
                    <div
                        v-if="indexOfSelectedCategory === index"
                        class="advance-number-of-catalogues-outer-container-xl"
                    >
                        <div
                            v-for="(dot, idx) in numberOfCatalogues()"
                            :key="idx"
                            class="advance-number-of-catalogues-inner-container-xl"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-wrap align-items-center mt-4">
                <div
                    v-for="(image, index) in catalogueImages"
                    :key="index"
                    class="advance-items-container-xl me-2"
                    @mouseenter="indexOfHoverItem = index"
                    @mouseleave="indexOfHoverItem = null"
                >
                    <div
                        v-lazy-container="{
                            selector: 'img',
                            error: '@/assets/dual-ring.svg',
                            loading: '@/assets/dual-ring.svg',
                        }"
                        class="advance-items-catalogue-xl"
                    >
                        <img
                            :data-src="`https://appbackend.revivoto.com${image.src}`"
                            alt=""
                            class="advance-items-poster-xl"
                        />
                    </div>

                    <div
                        :class="[
                            checkIncluded(image.id) === 'active'
                                ? 'advance-items-accent-layer-show-xl'
                                : 'advance-items-accent-layer-hide-xl',
                        ]"
                    ></div>

                    <div
                        :key="updateKey"
                        class="advance-items-checkbox-container-xl"
                        :class="[indexOfHoverItem === index ? 'opacity-1' : 'opacity-0']"
                    >
                        <div>
                            <div
                                :class="[
                                    checkIncluded(image.id) === 'active'
                                        ? 'advance-items-checkbox-bg-image-xl'
                                        : 'advance-items-checkbox-bg-color-xl',
                                ]"
                                @click="selecteCatalogue(image)"
                            ></div>
                        </div>

                        <div
                            class="advance-items-checkbox-expand-icon-xl"
                            @click="showCatalogueModal"
                        >
                            <img src="@/assets/services/expand-catalogues-icon.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="advance-notification-container-xl">
            <transition
                v-if="showNotification"
                enter-active-class="animate__animated animate__slideInLeft"
                leave-active-class="animate__animated animate__slideOutRight"
            >
                <Notification
                    :message="notifMessage"
                    :status="notifStatus"
                    @hideNotification="showNotification = false"
                />
            </transition>
        </div>
        <modal name="catalogue-modal" width="1120px" height="auto" :styles="modalStyle">
            <CatalogueModal
                :category="advancedModeCatalogs[indexOfSelectedCategory].name"
                :images="catalogueImages"
                :active-order-id="activeOrderId"
                :selected-id="selectedId"
                @update-selectede="updateSelectedCatalogue"
            />
        </modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CatalogueModal from '@/components/modals/cataloge-modal.vue';
import Notification from '@/components/snacks/index.vue';

export default {
    components: {
        CatalogueModal,
        Notification,
    },
    data() {
        return {
            showNotification: false,
            notifMessage: '',
            notifStatus: '',
            indexOfHoverItem: null,
            indexOfSelectedCategory: 0,
            selectedId: [],
            catalogueCategoryId: [],
            activeOrderId: null, // 0 equal Single case & the other numbers equal multiple index
            multiCataloguesTemp: [],
            showItemsMenu: false,
            activeOrderTitle: 'single',
            updateKey: 0,
            modalStyle: {
                borderRadius: '24px',
                boxShadow: '0px 4px 13px rgba(0, 0, 0, 0.15)',
            },
        };
    },
    computed: {
        ...mapState(['vsStore']),
        ...mapGetters([
            'virtualStagingStore',
            'advancedModeCatalogs',
            'multipleCatalogueLocal',
            'selectedSingleCatalogues',
            'catalogueTypeTitle',
            'activeMultipleIndex',
        ]),

        catalogueImages() {
            return this.advancedModeCatalogs[this.indexOfSelectedCategory].catalog_images;
        },
    },

    methods: {
        checkIncluded(id) {
            const { catalogueType, activeMultipleIndex, selectedMultipleCatalogues } = this.vsStore;
            let itemClass = '';
            if (catalogueType === 'single') {
                const [filteredCatalogue] = this.selectedSingleCatalogues.filter((item) => {
                    return item.id === id;
                });
                if (filteredCatalogue && !filteredCatalogue.delete) {
                    itemClass = 'active';
                } else {
                    itemClass = 'inactive';
                }
            } else {
                const multi = selectedMultipleCatalogues[activeMultipleIndex];

                const [filteredCatalogue] = multi.filter((item) => {
                    return item.id === id;
                });
                if (filteredCatalogue && !filteredCatalogue.delete) {
                    itemClass = 'active';
                } else {
                    itemClass = 'inactive';
                }
            }
            return itemClass;
        },

        updateSelectedCatalogue(arrayOfId) {
            this.selectedId = [...arrayOfId];
        },

        showCatalogueModal() {
            this.$modal.show('catalogue-modal');
        },
        numberOfCatalogues() {
            const {
                catalogueType,
                activeMultipleIndex,
                multipleCatalogueLocal,
                selectedSingleCatalogues,
            } = this.vsStore;

            let selectedCataLoguesId = [];
            let catalogueImagesID = [];
            this.catalogueImages.map((element) => {
                catalogueImagesID.push(element.id);
            });

            if (catalogueType === 'single') {
                selectedSingleCatalogues.map((item) => {
                    selectedCataLoguesId.push(item.id);
                });
            } else {
                multipleCatalogueLocal[activeMultipleIndex].map((item) => {
                    selectedCataLoguesId.push(item.id);
                });
            }

            let count = 0;
            catalogueImagesID.map((arr) => {
                if (selectedCataLoguesId.includes(arr)) {
                    count++;
                }
            });
            return count > 3 ? 3 : count;
        },
        changeCatalogue(index) {
            this.updateKey++;
            this.indexOfSelectedCategory = index;
        },
        changeCatalogueTypeTitle(type) {
            this.showItemsMenu = false;
            this.$store.commit('handleActiveMultipleIndex', type);
        },
        selecteCatalogue(catalogue) {
            const { catalogueType } = this.vsStore;
            if (catalogueType === 'single') {
                let singleData = {};
                singleData.catalogue = catalogue;
                this.$store.commit('handleSingleCataloguesXs', singleData);
                this.$store.commit('setSaveButtonTextVS', 'save-changes');
                this.$store.commit('handleVSChanges', true);
            } else {
                let lengthOfSelected = this.multipleCatalogueLocal[this.activeMultipleIndex].length;

                const catalogueIndex = this.multipleCatalogueLocal[
                    this.activeMultipleIndex
                ].findIndex((item) => {
                    return item.id === catalogue.id;
                });
                if (catalogueIndex < 0) {
                    if (lengthOfSelected > 2) {
                        this.showNotification = true;
                        this.notifMessage = 'You cannot choose more than three catalogs!';
                        this.notifStatus = 'warning';
                        return;
                    }

                    let multipleData = {};
                    multipleData.catalogue = catalogue;
                    this.$store.commit('handleMultipleCatalogues', multipleData);
                    this.$store.commit('setSaveButtonTextVS', 'save-changes');
                    this.$store.commit('handleVSChanges', true);
                    return;
                }

                let multipleData = {};
                multipleData.catalogue = catalogue;
                this.$store.commit('handleMultipleCatalogues', multipleData);
                this.$store.commit('setSaveButtonTextVS', 'save-changes');
                this.$store.commit('handleVSChanges', true);
            }
        },
        newMultiple() {
            this.$store.commit('newMultiple');
            this.$store.commit('setSaveButtonTextVS', 'save-changes');
            this.$store.commit('handleVSChanges', true);
        },
    },
};
</script>

<style lang="scss" scoped>
.advance {
    &-select-output {
        &-container-xl {
            display: flex;
            justify-content: space-between;
            padding: 12px 24px;
            border: 2px solid #ededed;
            border-radius: 16px;
        }
    }
    &-select-catalogues {
        &-container-xl {
            border: 2px solid #ededed;
            border-radius: 16px;
            padding: 16px 0 0 16px;
            background-color: #fff;
            margin-top: 16px;
        }
    }
    &-drop-menu {
        &-outer-container-xl {
            position: relative;
        }
        &-collapse {
            &-container-xl {
                width: 128px;
                height: 24px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 8px;
                box-shadow: $Black-Shadow;
                border-radius: 8px;
                cursor: pointer;
            }
        }
        &-expand {
            &-container-xl {
                width: 128px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                padding: 0 8px;
                box-shadow: $Black-Shadow;
                border-radius: 8px;
                cursor: pointer;
                font-size: 12px;
                color: $Primary-Text-Color;
                line-height: 24px;
                background-color: #fff;
                padding-left: 8px;
                padding-bottom: 12px;
                position: absolute;
                z-index: 3;
            }
        }
    }
    &-items {
        &-container-xl {
            position: relative;
            width: 31%;
            max-width: 176px;
            height: 100px;
            margin-bottom: 8px;
        }
        &-catalogue-xl {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }
        }
        &-title-xl {
            width: 100%;
            height: 38px;
            line-height: 38px;
            position: absolute;
            z-index: 1;
            bottom: 0;
            text-align: center;
            color: $White-Color;
            font-weight: bold;
            background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
            opacity: 0.88;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
        &-checkbox {
            &-container-xl {
                width: 24px;
                height: 100%;
                position: absolute;
                top: 0px;
                right: 8px;
                z-index: 3;
                padding-top: 8px;
                transition: opacity 0.8s;
            }
            &-input-xl {
                position: absolute;
                top: 0;
                right: 0;
                z-index: 2;
                width: 24px;
                height: 24px;
                opacity: 0;
            }
            &-bg-image-xl {
                background: url('~@/assets/services/tick.svg');
                border-radius: 8px;
                position: absolute;
                background-position: center;
                background-size: contain;
                box-shadow: $Active-Shadow;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
            &-bg-color-xl {
                width: 24px;
                height: 24px;
                background-color: $White-Color;
                box-shadow: $Black-Shadow;
                border-radius: 8px;
                position: absolute;
                cursor: pointer;
            }
            &-expand-icon-xl {
                @include centerByFlex;
                position: absolute;
                bottom: 8px;
                width: 24px;
                height: 24px;
                z-index: 5;
                border-radius: 50%;
                background-color: rgba($color: #fff, $alpha: 0.75);
                box-shadow: $Black-Shadow;
                cursor: pointer;
            }
        }
        &-accent-layer {
            &-show-xl {
                opacity: 1;
                width: 100%;
                max-width: 176px;
                height: 100px;
                position: absolute;
                top: 0;
                margin-bottom: 8px;
                background-color: rgba($color: #707ac9, $alpha: 0.5);
                border-radius: 8px;
                z-index: 1;
                transition: opacity 0.7s;
            }
            &-hide-xl {
                opacity: 0;
                transition: all 5s;
            }
        }
    }
    &-number-of-catalogues {
        &-outer-container-xl {
            display: flex;
            align-items: center;
            margin-top: 4px;
        }
        &-inner-container-xl {
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background-color: $Accent-Color;
            box-shadow: $Active-Shadow;
            margin-right: 4px;
        }
    }
    &-notification {
        &-container-xl {
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 10;
        }
    }
}
</style>
